/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MedicalRecord } from './MedicalRecord';
import {
    MedicalRecordFromJSON,
    MedicalRecordFromJSONTyped,
    MedicalRecordToJSON,
} from './MedicalRecord';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface MedicalRecordPagination
 */
export interface MedicalRecordPagination {
    /**
     * 
     * @type {Array<MedicalRecord>}
     * @memberof MedicalRecordPagination
     */
    data?: Array<MedicalRecord>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof MedicalRecordPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the MedicalRecordPagination interface.
 */
export function instanceOfMedicalRecordPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MedicalRecordPaginationFromJSON(json: any): MedicalRecordPagination {
    return MedicalRecordPaginationFromJSONTyped(json, false);
}

export function MedicalRecordPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalRecordPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(MedicalRecordFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function MedicalRecordPaginationToJSON(value?: MedicalRecordPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(MedicalRecordToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

